<!-- eslint-disable @angular-eslint/template/elements-content -->
<div class="home-page-container flex justify-center">
  <div class="home-page-content-wrapper  w-[80vw]">
    <div class="home-page-header-container ">
      <div class="home-resources-container">
        <video id="myVideo" controls autoplay muted>
          <source src="{{ deployUrlHost }}/assets/2021_CIB_BRIO_Update_EN-0x720-1200k.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <div class="flex flex-col px-4 justify-center resource-container">
          <div *ngFor="let item of documentsForHandBookAndIOSCOInfo()" class="resource-wrapper">
            <div class="labels-container">
              <div class="company-label">BNP PARIBAS</div>
              <div class="document-label">{{item.Title}}</div>
            </div>
            <a href="javascript:void(0)"  class="resource-link" (click)="onDownloadDocument(item)">
              <img width="25px" height="29px" src="{{ deployUrlHost }}/assets/PDF_icon.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bg-gray-100 flex justify-center border-t-gray-300 border-t-1 ">
  <div class="flex w-[80vw] grid-cols-4 text-sm text-gray-800 flex-col">
    <div>
      <!--<div class="flex flex-wrap items-center justify-between gap-4 my-6">
        <h2 class="text-lg font-medium text-black border-l-4 pl-2  border-green-700">Performance Table</h2>
        <span class="text-sm text-gray-600">Net of embedded of fees</span>
      </div>-->
      <div class="flex  items-center   border-gray-300 pr-4 my-6">
        <h2 class="text-lg font-medium text-black border-l-4 pl-2  border-green-700 pr-2"><span
            class="font-bold">Performance Table</span></h2>
        <span class="text-sm text-gray-600 border-l-2 border-gray-300 pl-2">Net of embedded fees</span>
      </div>
      <div class="flex justify-between py-4 align-end">
        <div class="w-[75%] gap-3 flex align-end">
          <div class="dropdown-container">
            <label class="font-semibold" for="asset-dropdown">Asset</label>
            <p-dropdown id="asset-dropdown" [options]="assets" [(ngModel)]="filter.asset" placeholder="ALL"
              (onChange)="setFilters('asset')" class="w-full"></p-dropdown>
          </div>
          <div class="dropdown-container">
            <label class="font-semibold" for="style-dropdown">Style</label>
            <p-dropdown id="style-dropdown" [options]="productstyles" [(ngModel)]="filter.productstyle"
              placeholder="ALL" class="w-full" (onChange)="setFilters('productstyle')"></p-dropdown>
          </div>
          <div class="dropdown-container">
            <label class="font-semibold" for="geography-dropdown">Geography</label>
            <p-dropdown id="geography-dropdown" [options]="geographies" [(ngModel)]="filter.geography" placeholder="ALL"
              class="w-full" (onChange)="setFilters('geography')"></p-dropdown>
          </div>
          <div class="dropdown-container">
            <label class="font-semibold" for="type-dropdown">Type</label>
            <p-dropdown id="type-dropdown" [options]="producttypes" [(ngModel)]="filter.productType" placeholder="ALL"
              class="w-full" (onChange)="setFilters('productType')"></p-dropdown>
          </div>
          <div class="dropdown-container">
            <label class="font-semibold" for="currency-dropdown">Currency</label>
            <p-dropdown id="currency-dropdown" [options]="currencies" [(ngModel)]="filter.currency" placeholder="ALL"
              class="w-full" (onChange)="setFilters('currency')"></p-dropdown>
          </div>
          <button pButton type="button" label="Reset" (click)="resetFilter()" class="reset-button"></button>
        </div>
        <div>
          <button pButton type="button" icon="pi pi-file-excel" label="Export Data" (click)="exportExcel()"
            class="bg-bnpp-green text-white"></button>
        </div>
      </div>
      <div class="flex performance-tabs gap-2 my-4">
        <p-tabs class="w-[100%]  " value="0">
          <p-tablist>
            <p-tab value="0" class=" w-[50%] flex items-center !gap-2 text-inherit bg-gray-100">
              <button class="px-4 py-2 text-white rounded font-medium w-[100%] bg-black"
                (click)="tab='cumulative'">Cumulative performance</button>
            </p-tab>
            <p-tab value="1" class="w-[50%] flex items-center !gap-2 text-inherit bg-gray-100">
              <button class="px-4 py-2 text-white rounded font-medium w-[100%] bg-black"
                (click)="tab='calendar'">Calendar performance</button>
            </p-tab>
            <div *ngIf="!indexPerformanceTableInfo()" class="absolute inset-0 flex items-center justify-center z-50">
              <p-progressSpinner styleClass="w-16 h-16" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
            </div>
          </p-tablist>
          <p-tabpanel class="mt-4" value="0">
            <bnpp-indx-home-performance [activeTab]="tab" [totalRecordsCount]="performanceDataTotalRecords"
              [performanceTableData]="filteredData"></bnpp-indx-home-performance>
          </p-tabpanel>
          <p-tabpanel class="mt-4" value="1">
            <bnpp-indx-home-performance [activeTab]="tab" [totalRecordsCount]="performanceDataTotalRecords"
              [performanceTableData]="filteredData"></bnpp-indx-home-performance>
          </p-tabpanel>
        </p-tabs>
      </div>
    </div>
    <bnpp-indx-home-disclaimer></bnpp-indx-home-disclaimer>
  </div>
</div>
